import { hydrateRoot } from 'react-dom/client';
import { ApiProvider, Router } from 'arcway/lib/client';
import Component from '/workspace/apps/mono/pages/legal/privacy.jsx';

const container = document.getElementById('__app');
const propsEl = document.getElementById('__app_props');
const props = propsEl ? JSON.parse(propsEl.textContent || '{}') : {};
const routeParamsEl = document.getElementById('__app_route_params');
const routeParams = routeParamsEl ? JSON.parse(routeParamsEl.textContent || '{}') : props;
const ROOT_KEY = '__arcway_root__';
const rootOwner = window;
const element = <ApiProvider><Router initialPath={window.location.pathname} initialParams={routeParams} initialPageProps={props} initialPattern={"/legal/privacy"} initialComponent={Component} initialLayouts={[]} initialLoadings={[]} /></ApiProvider>;

if (!container) {
  throw new Error('Arcway hydrate entry could not find #__app');
}

if (!rootOwner[ROOT_KEY]) {
  rootOwner[ROOT_KEY] = hydrateRoot(container, element);
} else {
  rootOwner[ROOT_KEY].render(element);
}
